<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-12
       SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .panel-body
            .form-horizontal
              .form-group
                label.col-sm-4.control-label IP
                .col-sm-8
                  IpAddressControl(v-model="ip")

              .form-group
                label.col-sm-4.control-label Expires In
                .col-sm-8
                  div.flex.horizontal
                    div(style="width: 40%; padding-right: 5px")
                      input.form-control.text-right.expires-in-input(type="number" v-model="expires.val")
                    div(style="width: 60%;")
                      select.form-control(id="expires-value-select" v-model="expires.unit")
                        option(v-for="o in units" :value="o.ms") {{o.label}}
              .form-group
                label.col-sm-4.control-label Reason
                .col-sm-8
                  input.form-control.ban-reason-input(type="text" v-model="reason")
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import auth from '@/service/AuthService'
import IpAddressControl from '@/components/common/IpAddressControl'
import { dateFilter } from '@/filters/filters'

export default {
  data() {
    const username = auth.getUsername()
    const MINUTE_MS = 60 * 1000
    const HOUR_MS = 60 * MINUTE_MS
    const DAY_MS = 24 * HOUR_MS
    return {
      saving: false,
      units: [{
        ms: MINUTE_MS,
        label: 'Minutes'
      }, {
        ms: HOUR_MS,
        label: 'Hours'
      }, {
        ms: DAY_MS,
        label: 'Days'
      }],
      expires: {
        val: 1,
        unit: DAY_MS
      },
      ip: null,
      reason: `Manual ban by ${username}`,
      errorMsg: null
    }
  },
  methods: {
    save() {
      this.saving = true
      const req = {
        ip: this.ip,
        expires: this.expiresDate,
        reason: this.reason
      }

      Security.banIp(req)
        .then((resp) => {
          miniToastr.success(`${resp.data.ip} was banned`)
          this.$router.push({ name: 'banned' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    expiresDate() {
      const now = new Date().getTime()
      return new Date(now + (this.expires.val * this.expires.unit))
    },
    isValid() {
      return this.ip
    }
  },
  components: {
    IpAddressControl
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/system/BanIP.vue